import * as THREE from "three";
import * as CANNON from "cannon";
import {
  createNewDiceBox,
  initSceneAndWorld,
  initGravity,
  initMaterialsAndCollisions,
  resizeRendererToCanvas,
  resetCameraPosition,
  resetAmbientLight,
  resetSpotlight,
  resetDesktopSurface,
  resetDeskGeometry,
  resetDiceBoxWallsGeometry,
  resetDiceColor,
  resetLabelColor,
  removeDiceSelectorPaneSurface,
  removeRolledDice,
  addRolledDice,
  _animate
} from "./diceBoxSimulation";

import {
  getDiceLaunchVectors,
  getLaunchVectorAndBoost,
  resetAnimationTracking,
  prepAnimation,
  prepareDiceForRoll,
  render
} from "./diceBoxSimulationHelpers";

export const defaultNewDiceBox = createNewDiceBox();
export const defaultScene = new THREE.Scene();
export const defaultWorld = new CANNON.World();
export const initDiceBox = (
  state = createNewDiceBox(),
  scene = defaultScene,
  world = defaultWorld
) => {
  let interimState = initSceneAndWorld(state, { scene, world });
  interimState = initGravity(interimState);
  return initMaterialsAndCollisions(interimState);
};

export const resetDiceBoxDisplay = (diceBox, props) => {
  const {
    ambientLightColor,
    deskColor,
    diceColor,
    labelColor,
    spotlightColor
  } = props ?? {};

  let interimState = resizeRendererToCanvas(diceBox);
  interimState = resetCameraPosition(interimState);
  interimState = resetAmbientLight(interimState, ambientLightColor);
  interimState = resetSpotlight(interimState, spotlightColor);
  interimState = resetDesktopSurface(interimState, deskColor);
  interimState = resetDiceColor(interimState, diceColor);
  interimState = resetLabelColor(interimState, labelColor);
  interimState = resetDeskGeometry(interimState);
  interimState = resetDiceBoxWallsGeometry(interimState);
  render(interimState);
  return interimState;
};

// dice = [`d6`, `d6`, `d6`...]
export const rollDice = (
  diceBox,
  { diceTypes = [], swipeInfo = {}, pregenResults }
) => {
  const { width, height, scale } = diceBox;
  const { isAnimationRunning } = diceBox;

  if (isAnimationRunning) return diceBox;

  const { launchVector, boost } = getLaunchVectorAndBoost({
    viewWidth: width,
    viewHeight: height,
    swipeInfo
  });
  const diceTypesWithVectors = getDiceLaunchVectors({
    width,
    height,
    diceTypes,
    vector: launchVector,
    boost
  });
  const dice = prepareDiceForRoll({
    scale,
    diceTypesWithVectors,
    diceColor: diceBox.diceColor,
    labelColor: diceBox.labelColor
  });

  let interimState = removeDiceSelectorPaneSurface(diceBox);
  interimState = removeRolledDice(interimState);
  interimState = resetAnimationTracking(interimState);

  /* Reenable later, maybe  
    if (pregenResults) {
      use_adaptive_timestep = false; // this is used to constrain the frame_rate during display
      while (!checkIfThrowFinished()) {
        ++animationIteration;
        diceBoxWorld.step(frame_rate);
      }
  
      const results = get_dice_values(rolledDice);
      prepareDiceForRoll(diceWithVectors); // this resets the dice positions
      shift_dice_faces(pregenResults, results);
    } */
  interimState = addRolledDice(interimState, { dice });
  interimState = prepAnimation(interimState);

  // this is effectively a separate thread, sort-of blocking, and any changes should be tracked by reference
  _animate(interimState);

  return interimState;
};
